// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + "reactPlayerPreview" + "." + "cc276e0b" + ".chunk.js";
};